import GenericSvgIcon from "@Icons/GenericSvgIcon";
import IconType from "@/types/Icon.type";
import {Colors} from "@Styles/Colors.style";

function IconMealsGroupNotAvailable(props: IconType) {
    const {
        width = "16",
        height = "16",
        fill = Colors.primaryColor,
        viewBox = "0 0 16 16",
        ...rest
    } = props

    return (
        <GenericSvgIcon
            {...{width, height, viewBox, ...rest}}
            svgIconPath={(
                <g fill={fill} fillRule="nonzero" transform="translate(.8327 1.53)">
                    <path
                        d="m12.8851.228127c-.6985-.403279-1.5917-.1639554-1.995.534544-.4033.698499-.1639 1.591669.5346 1.994949.6984.40328 1.5916.16395 1.9949-.53455s.164-1.591664-.5345-1.994943zm-.5509.954053c.1716.09906.2304.31848.1313.49007-.099.1716-.3184.23039-.49.13132s-.2304-.31849-.1313-.49008c.099-.17159.3184-.23038.49-.13131z"
                    />
                    <path
                        d="m4.12594 3.5267c-.26345-.1521-.60033-.06183-.75243.20162-.15211.26345-.06184.60033.20161.75243l7.01648 4.05099c.2635.15211.6004.06184.7525-.20161s.0618-.60033-.2016-.75243z"
                    />
                    <path
                        d="m11.1425 7.5777c-.2635-.15211-.6004-.06184-.7525.20161s-.0618.60033.2016.75243l3.4192 1.97406c.2634.1521.6003.0618.7524-.2016.1521-.2635.0619-.60035-.2016-.75246z"
                    />
                    <path
                        d="m9.49376.768476c-2.32573-.16162-4.19401.961074-5.54106 3.294244l.95405.55082c1.14667-1.9861 2.62895-2.87684 4.51063-2.74608z"
                    />
                    <path
                        d="m12.4471 1.67507-.6957.85411c2.4472 1.99357 2.8894 4.2078 1.3754 6.83021l.954.55082c1.7881-3.09697 1.2273-5.90452-1.6337-8.23514z"
                    />
                    <path
                        d="m.885004 12.8659c-.359332 0-.650629.2466-.650629.5508s.291297.5508.650629.5508h9.570096c.8226 0 .8226-1.1016 0-1.1016z"
                    />
                    <path
                        d="m10.4551 12.8659c-.82266 0-.82266 1.1016 0 1.1016h4.6635c.3593 0 .6506-.2466.6506-.5508s-.2913-.5508-.6506-.5508z"
                    />
                </g>
            )}
        />
    )
}

export default IconMealsGroupNotAvailable